import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Package } from 'lucide-react';
export function TomoIncludes() {
  const items = ['Plantillas de aplicación', 'Formatos de registro', 'Fichas de seguimiento', 'Recursos imprimibles', 'Materiales listos para sesiones e intervenciones'];
  return <section className="py-16 bg-brand-50" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-brand-100 relative overflow-hidden" data-id="element-169">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-brand-100 rounded-full opacity-50 blur-2xl" data-id="element-170"></div>

          <div className="relative z-10" data-id="element-171">
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4" data-id="element-172">
              Todos los tomos incluyen plantillas listas para usar
            </h3>
            <p className="text-lg text-gray-600 mb-8" data-id="element-173">
              No son solo actividades sueltas. Cada tomo fue pensado para
              ayudarte a aplicar, registrar y dar seguimiento sin empezar de
              cero cada vez.
            </p>

            <div className="mb-6" data-id="element-174">
              <h4 className="font-bold text-gray-900 mb-4" data-id="element-175">Incluyen:</h4>
              <div className="flex flex-wrap gap-3" data-id="element-176">
                {items.map((item, i) => <div key={i} className="flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full text-sm font-medium text-gray-700 shadow-sm" data-id="element-177">
                    <CheckCircle2 className="w-4 h-4 text-brand-600" data-id="element-178" />
                    {item}
                  </div>)}
              </div>
            </div>

            <div className="mt-10 bg-brand-600 rounded-2xl p-6 text-white flex items-center gap-4 shadow-lg transform hover:scale-[1.02] transition-transform" data-id="element-179">
              <div className="bg-white/20 p-3 rounded-xl" data-id="element-180">
                <Package className="w-8 h-8" data-id="element-181" />
              </div>
              <div data-id="element-182">
                <div className="text-brand-100 font-medium text-sm" data-id="element-183">
                  Lo que te llevás
                </div>
                <div className="text-xl md:text-2xl font-black" data-id="element-184">
                  📦 +1.200 páginas de material profesional
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}